import axios from "axios";
import config from "../config";

const BASE_URL = config.baseApi;

// Reuse the same token retrieval logic as serviceFee.service
const getAdminToken = () => {
  try {
    let token = localStorage.getItem("admin_token");

    if (!token) {
      const carMeetStorageString = localStorage.getItem("car-meet-storage");
      if (carMeetStorageString) {
        try {
          const carMeetStorage = JSON.parse(carMeetStorageString);
          token = carMeetStorage?.token || null;
        } catch (e) {
          console.error("TicketService: Error parsing car-meet-storage:", e);
        }
      }
    }

    return token;
  } catch (error) {
    console.error("TicketService: Error getting admin token:", error);
    return null;
  }
};

const TicketService = {
  /**
   * Get sold tickets list for Ticket Revenue tab
   * @param {Object} params
   * @param {number} params.page
   * @param {number} params.limit
   * @param {string} [params.startDate]
   * @param {string} [params.endDate]
   * @param {string} [params.searchtext]
   */
  async getSoldTickets(params = {}) {
    const token = getAdminToken();
    if (!token) {
      const error = new Error("Admin token not found in localStorage");
      error.isTokenError = true;
      throw error;
    }

    if (!BASE_URL) {
      const error = new Error("Base API URL is not configured");
      error.isConfigError = true;
      throw error;
    }

    const url = `${BASE_URL}/api/v1/admin/dashboard/sold-tickets`;

    try {
      const response = await axios.post(url, params, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        timeout: 30000,
      });

      return response;
    } catch (error) {
      console.error("TicketService: Error fetching sold tickets", {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url,
      });
      throw error;
    }
  },
};

export default TicketService;


